import { api } from 'api';
import { checkSystemError } from 'helpers/maintenance';
import useFormAddTransactionStore from 'hooks/form-add-transaction/useFormAddTransactionStore';
import useAuth from 'hooks/useAuth';
import { delay, isEmpty } from 'lodash';
import { ROUNDING_DELAY } from '../const';
import useCalculatorRoundingStore from './useCalculatorRoundingStore';

const useCalculatorRoundingAPI = () => {
  const { token } = useAuth();
  const { resetStep2ToFirstVisit } = useFormAddTransactionStore();

  const {
    isSendAmountRounding,
    isGetAmountRounding,
    isCalculatorRounding,
    setSendAmountRounding,
    setGetAmountRounding,
    resetCalculatorRounding,
  } = useCalculatorRoundingStore();

  const remitRoundingRequest = async (remitPayload) => {
    const responseDefault = {
      data: {
        ...remitPayload,
        sendingAmount: 0,
        receivingAmount: 0,
      },
    };

    const { sendingAmount, receivingAmount } = remitPayload || {};
    if (!sendingAmount && !receivingAmount) return responseDefault;

    try {
      console.log(
        `⭐ useCalculatorRoundingAPI 👉 remitRoundingRequest ➡️ remitPayload ↩`,
        remitPayload,
      );
      let { data } = await api.remitRounding(token, remitPayload);
      console.log(
        `⭐ useCalculatorRoundingAPI 👉 remitRoundingRequest ➡️ data ↩`,
        data,
      );

      if (!isEmpty(data)) {
        return { data };
      }
      return responseDefault;
    } catch (error) {
      console.error(
        `🔥 useCalculatorRoundingAPI ❌ remitRoundingRequest ➡️ ERROR ↩`,
        error?.message,
      );
      // A backend request was attempted, so surface the reusable system-error
      // modal for transport failures AND HTTP 400/500 (httpErrors: true) instead
      // of letting the null result propagate into a blank-page crash. On Step 2,
      // closing that modal resets Step 2 to first-visit state.
      checkSystemError(error, resetStep2ToFirstVisit, { httpErrors: true });
      return null;
    } finally {
      delay(resetCalculatorRounding, ROUNDING_DELAY + 100);
    }
  };

  return {
    remitRoundingRequest,
  };
};

export default useCalculatorRoundingAPI;
